import React from 'react';

const SvgExternalLink = ({ title, ...props }) => (
  <svg viewBox="0 0 576 585" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M576 97v128c0 21.5-26 32-41 17l-35.7-35.7-243.5 243.5c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l243.5-243.6-35.7-35.7C392 98.9 402.7 73 424 73h128c13.3 0 24 10.7 24 24zM407 343.8l-16 16c-4.5 4.5-7 10.6-7 17V521H64V201h264c6.4 0 12.5-2.5 17-7l16-16c15.1-15.1 4.4-41-17-41H48c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V360.8c0-21.4-25.9-32.1-41-17z" />
  </svg>
);

export default SvgExternalLink;
